/* tp-fluid: partea de JS pentru tranzitiile intre pagini. Fara efect in browsere fara View Transitions. */
(function () {
  'use strict';
  var off = /[?&]tps=0(&|$)/.test(location.search);
  function safe(f) { try { return f(); } catch (e) {} }

  /* ultimul card atins (pentru tranzitia poza -> galerie) */
  var lastCard = null;
  document.addEventListener('pointerdown', function (e) {
    lastCard = e.target && e.target.closest ? e.target.closest('.tp-app-card, .tp-card') : null;
  }, true);

  function isProduct(u) { try { return new URL(u, location.href).pathname.indexOf('/products/') === 0; } catch (e) { return false; } }

  /* pagina care pleaca */
  window.addEventListener('pageswap', function (e) {
    safe(function () {
      if (off) { if (e.viewTransition) e.viewTransition.skipTransition(); return; }
      if (!e.viewTransition || !e.activation || !e.activation.entry) return;
      var to = e.activation.entry.url;
      if (!isProduct(to) || !lastCard) return;
      var img = lastCard.querySelector('.tp-app-card-slide img, .tp-card-img img');
      if (img) img.style.viewTransitionName = 'tpf-hero';
      var pr = lastCard.querySelector('.tp-app-card-price strong, .tp-card-price');
      if (pr) pr.style.viewTransitionName = 'tpf-price';
    });
  });

  /* pagina care soseste */
  window.addEventListener('pagereveal', function (e) {
    safe(function () {
      if (!e.viewTransition) return;
      if (off) { e.viewTransition.skipTransition(); return; }
      if (!isProduct(location.href)) return;
      var img = document.querySelector('.tp-pdp-slide img');
      if (img) img.style.viewTransitionName = 'tpf-hero';
      var pp = document.querySelector('[data-tp-price]');
      if (pp) pp.style.viewTransitionName = 'tpf-price';
      var clr = function () { if (img) img.style.viewTransitionName = ''; if (pp) pp.style.viewTransitionName = ''; };
      e.viewTransition.finished.then(clr, clr);
    });
  });

  /* inapoi din bfcache: curata orice nume ramas pe poza cardului */
  window.addEventListener('pageshow', function () {
    safe(function () { var l = document.querySelectorAll('.tp-app-card-slide img, .tp-card-img img, .tp-app-card-price strong, .tp-card-price'); for (var i = 0; i < l.length; i++) l[i].style.viewTransitionName = ''; });
  });

  /* feedback instant la atingere: bara subtire sus porneste in aceeasi clipa (prerender/prefetch fac restul) */
  safe(function () {
    var bar = document.createElement('div'); bar.className = 'tpf-bar'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var root = document.documentElement;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
      root.classList.add('tpf-go');
    }, true);
    window.addEventListener('pageshow', function () { root.classList.remove('tpf-go'); });
  });
})();


/* ==== premium-20261020 (inceput) ==== */
/* Linkurile interne spre colectii merg direct pe varianta "in stoc": altfel pagina se incarca si se randeaza de doua ori
   (varianta completa, apoi cea filtrata adusa prin AJAX de scriptul care bifeaza singur "In stoc"). */
(function () {
  'use strict';
  try {
    var ua = navigator.userAgent || '';
    if (/googlebot|bingbot|adsbot|slurp|duckduckbot|baiduspider|yandex|facebookexternalhit|storebot|google-inspectiontool|petalbot|applebot|semrush|ahrefs/i.test(ua)) return;
    if (/[?&]tps=0(&|$)/.test(location.search)) return;
    var SKIP = { vendors: 1, types: 1 };
    /* paginile-hub (fara lista de produse) nu au filtru "in stoc": le lasam neatinse */
    var HUB = /^(tp-(women|men|kids|sport)-.+|pantofi-sport|ghete-barbati|pantofi-barbati|ghete-dama|pantofi-dama|copii|dama|barbati|pantofi-copii)$/;
    var off = function () { try { return sessionStorage.getItem('tp_in_stock_user_preference') === 'unchecked'; } catch (e) { return false; } };
    var fix = function (a) {
      if (!a || !a.getAttribute || a.dataset.tppIs) return;
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#') return;
      var u; try { u = new URL(h, location.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      var m = u.pathname.match(/^\/collections\/([^/]+)\/?$/);
      if (!m) return;
      var hd; try { hd = decodeURIComponent(m[1]).normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { return; }
      if (SKIP[hd] || HUB.test(hd)) return;
      a.dataset.tppIs = '1';
      if (off() || u.searchParams.has('filter.v.availability')) return;
      u.searchParams.set('filter.v.availability', '1');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    };
    var onEv = function (e) { var a = e.target && e.target.closest ? e.target.closest('a[href]') : null; if (a) fix(a); };
    ['pointerover', 'touchstart', 'focusin', 'click'].forEach(function (t) { document.addEventListener(t, onEv, { capture: true, passive: true }); });
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1500); };
    idle(function () { var l = document.querySelectorAll('a[href*="/collections/"]'); for (var i = 0; i < l.length; i++) fix(l[i]); }, { timeout: 4000 });
  } catch (e) {}
})();
/* ==== premium-20261020 (sfarsit) ==== */

/* ==== premium-qa-20261020 (inceput) ==== */
/* "Adauga rapid" din carduri: formularele /cart/add (cate unul pe marime) se creeaza abia cand cineva deschide popover-ul.
   ~500 de formulare pe o colectie costau 1-2 s la incarcare in scriptul Shopify care parcurge toate formularele paginii. */
(function () {
  'use strict';
  function fill(det) {
    var t = det.querySelector('template[data-tp-qa-tpl]');
    var box = det.querySelector('[data-tp-qa-box]');
    if (!t || !box) return;
    box.appendChild(t.content.cloneNode(true));
    t.remove();
  }
  function pre(e) {
    var d = e.target && e.target.closest ? e.target.closest('details.tp-quick-add') : null;
    if (d) fill(d);
  }
  ['pointerdown', 'touchstart', 'focusin', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, pre, { capture: true, passive: true }); });
  document.addEventListener('toggle', pre, true);
})();
/* ==== premium-qa-20261020 (sfarsit) ==== */
